import { post,put,del,get } from './axios'

export const popupList = async (params) => {
  const { status, data } = await get("/popup/selectPopupAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
  
}

export const popupDetail = async (params) => {
  const { status, data } = await get("/popup/selectPopupDetailAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
  
}
